/**
 * Resolve class icon URL from API payloads that may use different field names.
 */
export function getClassIconUrl(cls) {
  if (!cls || typeof cls !== 'object') return '';
  const candidates = [
    cls.iconUrl,
    cls.iconURL,
    cls.IconUrl,
    cls.imageUrl,
    cls.imageURL,
    typeof cls.icon === 'string' ? cls.icon : null,
    typeof cls.Icon === 'string' ? cls.Icon : null,
    cls.icon?.url,
    cls.icon_image,
    cls.icon_image_url,
    cls.metadata?.iconUrl,
    cls.metadata?.imageUrl,
    cls.picture,
    cls.avatarUrl,
    cls.logo,
  ];
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim()) return c.trim();
  }
  return '';
}

/** Merge normalized `iconUrl` onto a class object for UI / map markers */
export function withNormalizedClassIcon(cls) {
  const iconUrl = getClassIconUrl(cls);
  return { ...cls, iconUrl };
}
